export const OceanWiseAttribution = '&#169; British Crown and OceanWise, 2022. All rights reserved. License No. OW20220616. Not to be used for Navigation.';
